import { action } from "typesafe-actions";
import {
  IActivityComment,
  IBusinessTask,
  ICreateGroupPayload,
  IEmailConversationActivity,
  IGroup,
  IRestrictWhatsAppMessagePayload,
  ISMSActivity,
  IWhatsAppActivity,
  IWhatsAppActivityPayload,
  IWhatsAppGroupActivity,
  IWhatsAppStatusCount,
} from "./activity.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { ERROR_MESSAGES } from "../../constants/enums";
import { makeApiCall } from "../../helpers/postRequest";
import { IInvoiceInformation } from "../Accounting/InvoiceInformation/InvoiceInformation.types";
import { uploadMultipleFile } from "../../features/FileUpload/utils";
import { IFileUpload } from "../../features/FileUpload/components/FileUpload.type";
import { getUniqueId } from "../../helpers";
import moment from "moment";
import { STANDARD_APP_DATE_FORMAT } from "../../constants/constants";
import { generateAdvanceFilterQuery } from "../Accounting/AccountingReports/AccountingReportsActions";

export const FETCH_BUSINESS_TASKS_LIST_PROGRESS =
  "FETCH_BUSINESS_TASKS_LIST_PROGRESS";
export const FETCH_BUSINESS_TASKS_LIST_SUCCESS =
  "FETCH_BUSINESS_TASKS_LIST_SUCCESS";
export const FETCH_BUSINESS_TASKS_LIST_FAILED =
  "FETCH_BUSINESS_TASKS_LIST_FAILED";

export const fecthBusinessTasksListProgress = () =>
  action(FETCH_BUSINESS_TASKS_LIST_PROGRESS);
export const fecthBusinessTasksListSuccess = (
  data: IBusinessTask[],
  fromArchiveLoad?: boolean,
) => action(FETCH_BUSINESS_TASKS_LIST_SUCCESS, { data, fromArchiveLoad });
export const fecthBusinessTasksListFailed = () =>
  action(FETCH_BUSINESS_TASKS_LIST_FAILED);

export const fetchBusinessTasksListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number | null,
    status: string,
    newStatus: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    moduleId?: string,
    groupType?: string,
    moduleReferenceColumn?: string,
    searchState?: { [key: string]: any },
    customerId?: string,
    moduleName?: string,
    customerPolicyId?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const {
        module_reference_code_or_id,
        task_name,
        task_type,
        assigned_to_id,
      } = searchState || {};
      dispatch(fecthBusinessTasksListProgress());
      let finalUrl = `/tasks/get-task-module-wise?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      // &module_name=${moduleName}&sub_module_name=${subModuleName}

      if (limit) {
        finalUrl = finalUrl + `&pageLimit=${limit}`;
      }
      if (searchValue.length > 0) {
        finalUrl = `/tasks/get-task-module-wise?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (customerId) {
        const customerFilter = {
          column: ["customer_id"],
          operator: "EQUAL",
          value: customerId,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(customerFilter, null, 2),
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
        if (task_name) {
          const filterObj = {
            column: ["task_name"],
            operator: "EQUAL",
            value: task_name,
            logicalOperator: "AND",
          };
          const encodedTaskNameFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedTaskNameFilter}&`;
        }
        if (task_type && task_type !== "-1") {
          const filterObj = {
            column: ["task_type"],
            operator: "EQUAL",
            value: task_type,
            logicalOperator: "AND",
          };
          const encodedTaskTypeFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedTaskTypeFilter}&`;
        }
        if (assigned_to_id) {
          const filterObj = {
            column: ["assigned_to_id"],
            operator: "EQUAL",
            value: assigned_to_id,
            logicalOperator: "AND",
          };
          const encodedAssignedFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedAssignedFilter}&`;
        }
        if (newStatus !== "-1") {
          finalUrl += "&status=" + newStatus;
        }
        if (groupType !== "-1" && groupType !== undefined) {
          finalUrl += "&group_of=" + groupType;
        }
      } else if (customerPolicyId) {
        // Filter purely by customer_policy_id (used by the Comm Auto activities
        // tab) instead of module_reference_code_or_id, and without the default
        // module_name advanced filter query.
        const customerPolicyFilter = {
          column: ["customer_policy_id"],
          operator: "EQUAL",
          value: customerPolicyId,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(customerPolicyFilter),
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
        if (status !== "-1") {
          const filterObj = {
            column: ["task_type"],
            operator: "EQUAL",
            value: status,
            logicalOperator: "AND",
          };
          const encodedStatusFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedStatusFilter}&`;
        }
        if (task_name) {
          const filterObj = {
            column: ["task_name"],
            operator: "EQUAL",
            value: task_name,
            logicalOperator: "AND",
          };
          const encodedTaskNameFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedTaskNameFilter}&`;
        }
        if (task_type) {
          const filterObj = {
            column: ["task_type"],
            operator: "EQUAL",
            value: task_type,
            logicalOperator: "AND",
          };
          const encodedTaskTypeFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedTaskTypeFilter}&`;
        }
        if (assigned_to_id) {
          const filterObj = {
            column: ["assigned_to_id"],
            operator: "EQUAL",
            value: assigned_to_id,
            logicalOperator: "AND",
          };
          const encodedAssignedFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedAssignedFilter}&`;
        }
        if (newStatus !== "-1") {
          finalUrl += "&status=" + newStatus;
        }
        if (groupType !== "-1" && groupType !== undefined) {
          finalUrl += "&group_of=" + groupType;
        }
      } else {
        if (moduleId) {
          finalUrl += `&module_reference_code_or_id=${moduleId}`;
        }
        if (moduleName) {
          // Match both the short module name and the "<Name> Policy" variant
          // (e.g. "Commercial Auto" OR "Commercial Auto Policy") using an IN filter.
          const moduleNameFilter = {
            column: ["module_name"],
            operator: "IN",
            value: [moduleName, `${moduleName} Policy`],
            logicalOperator: "AND",
          };
          const encodedFilter = encodeURIComponent(
            JSON.stringify(moduleNameFilter),
          );
          finalUrl += `&advanceFilter=${encodedFilter}&`;
        }
        if (moduleReferenceColumn) {
          const filterObj = {
            column: ["module_reference_column"],
            operator: "EQUAL",
            value: moduleReferenceColumn,
            logicalOperator: "AND",
          };
          const encodedFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedFilter}&`;
        }
        if (status !== "-1") {
          const filterObj = {
            column: ["task_type"],
            operator: "EQUAL",
            value: status,
            logicalOperator: "AND",
          };
          const encodedFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedFilter}&`;
        }
        if (module_reference_code_or_id) {
          finalUrl += `&module_reference_code_or_id=${module_reference_code_or_id}`;
        }
        if (task_name) {
          const filterObj = {
            column: ["task_name"],
            operator: "EQUAL",
            value: task_name,
            logicalOperator: "AND",
          };
          const encodedFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedFilter}&`;
        }
        if (task_type) {
          const filterObj = {
            column: ["task_type"],
            operator: "EQUAL",
            value: task_type,
            logicalOperator: "AND",
          };
          const encodedFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedFilter}&`;
        }
        if (assigned_to_id) {
          const filterObj = {
            column: ["assigned_to_id"],
            operator: "EQUAL",
            value: assigned_to_id,
            logicalOperator: "AND",
          };
          const encodedFilter = encodeURIComponent(
            JSON.stringify(filterObj, null, 2),
          );
          finalUrl += `&advanceFilter=${encodedFilter}&`;
        }
        if (newStatus !== "-1") {
          finalUrl += "&status=" + newStatus;
        }
        if (groupType !== "-1" && groupType !== undefined) {
          finalUrl += "&group_of=" + groupType;
        }
      }
      // if (taskType) {
      //   finalUrl += `&column=task_type&value=${taskType}`;
      // }
      const res = await api.get(finalUrl);
      const data: IBusinessTask[] = res.data.data;
      // if (data.length === 0) {
      //   dispatch(fecthBusinessTasksListFailed());
      //   dispatch(
      //     showMessage({
      //       type: "error",
      //       message: ERROR_MESSAGES.NO_RECORD_FOUND,
      //       displayAs: "snackbar",
      //     })
      //   );
      //   return;
      // }
      // Process file uploads
      const updatedTasks = data.map((task) => {
        const attachments: IFileUpload[] = [];
        for (const item of (task.file_upload || []) as any) {
          attachments.push({
            file: null,
            key: getUniqueId(), // Generate a unique key for each file
            path: item,
          });
        }
        return {
          ...task,
          file_upload: attachments,
        };
      });

      dispatch(fecthBusinessTasksListSuccess(updatedTasks));
      // Update total records in the state
      // (Removed incorrect dispatch with newState)

      // dispatch(fecthBusinessTasksListSuccess(data));
    } catch (err: any) {
      dispatch(fecthBusinessTasksListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };
export const fetchBusinessTasksListNewAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    // searchValue: IDatatableV2AdvancedSearchFilter,
    searchState: { [key: string]: any },
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const {
        module_reference_code_or_id,
        task_name,
        task_type,
        assigned_to_id,
        producer_one_code,
      } = searchState;
      dispatch(fecthBusinessTasksListProgress());
      let finalUrl = `/tasks/get-task-module-wise?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      if (module_reference_code_or_id) {
        finalUrl += `&module_reference_code_or_id=${module_reference_code_or_id}`;
      }
      if (task_name) {
        const filterObj = {
          column: ["task_name"],
          operator: "EQUAL",
          value: task_name,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2),
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      if (task_type !== "-1") {
        const filterObj = {
          column: ["task_type"],
          operator: "EQUAL",
          value: task_type,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2),
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      if (assigned_to_id) {
        const filterObj = {
          column: ["assigned_to_id"],
          operator: "EQUAL",
          value: assigned_to_id,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2),
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      if (producer_one_code) {
        const filterObj = {
          column: ["producer_one_code"],
          operator: "EQUAL",
          value: producer_one_code,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2),
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      const res = await api.get(finalUrl);
      const data: IBusinessTask[] = res.data.data;
      // if (data.length === 0) {
      //   dispatch(fecthBusinessTasksListFailed());
      //   dispatch(
      //     showMessage({
      //       type: "error",
      //       message: ERROR_MESSAGES.NO_RECORD_FOUND,
      //       displayAs: "snackbar",
      //     })
      //   );
      //   return;
      // }
      // Process file uploads
      const updatedTasks = data.map((task) => {
        const attachments: IFileUpload[] = [];
        for (const item of (task.file_upload || []) as any) {
          attachments.push({
            file: null,
            key: getUniqueId(), // Generate a unique key for each file
            path: item,
          });
        }
        return {
          ...task,
          file_upload: attachments,
        };
      });

      dispatch(fecthBusinessTasksListSuccess(updatedTasks));
      // Update total records in the state
      // (Removed incorrect dispatch with newState)

      // dispatch(fecthBusinessTasksListSuccess(data));
    } catch (err: any) {
      dispatch(fecthBusinessTasksListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const fetchDataTasksListFromArchiveAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchState: { [key: string]: any },
    searchValue?: IDatatableV2AdvancedSearchFilter,
    moduleId?: string, // Added moduleId to the parameters
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const { module_reference_code_or_id, task_name, task_type, producer_one_code } = searchState;
      dispatch(fecthBusinessTasksListProgress());
      let finalUrl = `/tasks/get-task-module-wise-archive?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      // &module_name=${moduleName}&sub_module_name=${subModuleName}

      if (searchValue && searchValue.length > 0) {
        finalUrl = finalUrl + `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (moduleId) {
        finalUrl += `&module_reference_code_or_id=${moduleId}`;
      }

      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      if (module_reference_code_or_id) {
        finalUrl += `&module_reference_code_or_id=${module_reference_code_or_id}`;
      }
      const filterObj = {
        column: ["module_reference_column"],
        operator: "EQUAL",
        value: "customer_policy_id",
        logicalOperator: "AND",
      };
      const encodedFilter = encodeURIComponent(
        JSON.stringify(filterObj, null, 2),
      );
      finalUrl += `&advanceFilter=${encodedFilter}`;
      if (task_name) {
        const filterObj = {
          column: ["task_name"],
          operator: "EQUAL",
          value: task_name,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2),
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      // if (task_type) {
      //   const filterObj = {
      //     column: ["task_type"],
      //     operator: "EQUAL",
      //     value: task_type,
      //     logicalOperator: "AND",
      //   };
      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }
      if (producer_one_code) {
        const filterObj = {
          column: ["producer_one_code"],
          operator: "EQUAL",
          value: producer_one_code,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2),
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      const res = await api.get(finalUrl);
      const data: IBusinessTask[] = res.data.data;
      const updatedTasks = data.map((task) => {
        const attachments: IFileUpload[] = [];
        for (const item of (task.file_upload || []) as any) {
          attachments.push({
            file: null,
            key: getUniqueId(),
            path: item,
          });
        }
        return {
          ...task,
          file_upload: attachments,
        };
      });

      dispatch(fecthBusinessTasksListSuccess(updatedTasks, true));
      // Update total records in the state
      // (Removed incorrect dispatch with newState)

      // dispatch(fecthBusinessTasksListSuccess(data));
    } catch (err: any) {
      dispatch(fecthBusinessTasksListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const fetchBusinessTasksListByModuleAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    date: IDataTableV2DateState["dates"],
     searchState: { [key: string]: any },
    task_type?: string,
   
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
         const {
            status,
              ...restSearchState
            } = searchState;
            const query = generateAdvanceFilterQuery(restSearchState);
      dispatch(fecthBusinessTasksListProgress());
      const apiName =
        task_type === "Approval"
          ? "/tasks/get-task-module-wise"
          : "/accounting/get-task-module-wise-only-for-accounting";
      let finalUrl = `${apiName}?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (query) {
        finalUrl += "&" + query;
      }
        if (status && status !== "-1") {
        finalUrl += "&status=" + status;
      }
     
     
      if (task_type) {
        finalUrl += `&column=task_type&value=${task_type}`;
      }
    
    

      const res = await api.get(finalUrl);
      const data: IBusinessTask[] = res.data.data;

      const updatedTasks = data.map((task) => {
        const attachments: IFileUpload[] = [];
        for (const item of (task.file_upload || []) as any) {
          attachments.push({
            file: null,
            key: getUniqueId(), // Generate a unique key for each file
            path: item,
          });
        }
        return {
          ...task,
          file_upload: attachments,
        };
      });

      dispatch(fecthBusinessTasksListSuccess(updatedTasks));
      // Update total records in the state
      // (Removed incorrect dispatch with newState)

      // dispatch(fecthBusinessTasksListSuccess(data));
    } catch (err: any) {
      dispatch(fecthBusinessTasksListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_BUSINESS_TASKS_PROGRESS = "FETCH_BUSINESS_TASKS_PROGRESS";
export const FETCH_BUSINESS_TASKS_SUCCESS = "FETCH_BUSINESS_TASKS_SUCCESS";
export const FETCH_BUSINESS_TASKS_FAILED = "FETCH_BUSINESS_TASKS_FAILED";
export const ADD_UPDATE_BUSINESS_TASK = "ADD_UPDATE_BUSINESS_TASK";

export const fetchBusinessTasksProgress = () =>
  action(FETCH_BUSINESS_TASKS_PROGRESS);
export const fetchBusinessTasksSuccess = (data: IBusinessTask[]) =>
  action(FETCH_BUSINESS_TASKS_SUCCESS, { data });
export const addUpdateBusinessTask = (data: IBusinessTask) =>
  action(ADD_UPDATE_BUSINESS_TASK, { data });
export const fetchBusinessTasksFailed = (errorMessage: string) =>
  action(FETCH_BUSINESS_TASKS_FAILED, { errorMessage });

export const fetchBusinessTasksAsync =
  (code?: any): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchBusinessTasksProgress());
      let finalUrl = `/tasks/get-task-module-wise?column=task_type&value=Events`;
      if (code) {
        finalUrl = `/tasks/get-task-module-wise?module_reference_code_or_id=${code}`;
      }

      const res = await api.get(finalUrl);
      const data: IBusinessTask[] = res.data.data;
      if (data.length > 0) {
        const updatedTasks = data.map((task) => {
          const attachments: IFileUpload[] = [];
          for (const item of (task.file_upload || []) as any) {
            attachments.push({
              file: null,
              key: getUniqueId(),
              path: item,
            });
          }
          return {
            ...task,
            file_upload: attachments,
          };
        });
        dispatch(fetchBusinessTasksSuccess(updatedTasks));
      } else {
        dispatch(fetchBusinessTasksFailed(ERROR_MESSAGES.NO_RECORD_FOUND));
      }
    } catch (err: any) {
      dispatch(fetchBusinessTasksFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const upsertBusinessTask =
  (
    data: IBusinessTask,
    initialData: IBusinessTask,

    isUpdate: boolean,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const asPayload = {
        task_name: data.task_name,
        module_reference_code_or_id: data.module_reference_code_or_id,
        transaction: "",
        sub_type: "",
        task_code: "",
      };

      const { paths } = await uploadMultipleFile(
        data.file_upload || [],
        "TASK",
        asPayload,
      );

      const res = await makeApiCall(
        {
          url: "/tasks/create-task-module-wise",
          method: "POST",
          automation: {
            primaryFieldName: "task_module_wise_code",
            isUpdate: isUpdate,
          },
        },
        initialData,
        {
          ...data,
          file_upload: paths,
        },
      );

      const task: IBusinessTask = res.data.data;
      dispatch(
        addUpdateBusinessTask({
          ...task,
          insert_ts: moment().format(STANDARD_APP_DATE_FORMAT),
        }),
      );

      dispatch(
        showMessage({
          type: "success",
          message: "Task created successfully",
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/*------------*/
export const FETCH_EMAIL_CONVERSATION_LIST_PROGRESS =
  "FETCH_EMAIL_CONVERSATION_LIST_PROGRESS";
export const FETCH_EMAIL_CONVERSATION_LIST_SUCCESS =
  "FETCH_EMAIL_CONVERSATION_LIST_SUCCESS";
export const FETCH_EMAIL_CONVERSATION_LIST_FAILED =
  "FETCH_EMAIL_CONVERSATION_LIST_FAILED";

export const fetchEmailConversationListProgress = () =>
  action(FETCH_EMAIL_CONVERSATION_LIST_PROGRESS);
export const fetchEmailConversationListSuccess = (
  data: IEmailConversationActivity[],
) => action(FETCH_EMAIL_CONVERSATION_LIST_SUCCESS, { data });
export const fetchEmailConversationListFailed = (errorMesssage: string) =>
  action(FETCH_EMAIL_CONVERSATION_LIST_FAILED, { errorMesssage });

export const fetchEmailConversationListAsync =
  (code: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchEmailConversationListProgress());

      const res = await api.get(
        `/general/get-email-history?module_code=${code}`,
      );
      const data: IEmailConversationActivity[] = res.data.data;
      dispatch(fetchEmailConversationListSuccess(data));
    } catch (err: any) {
      dispatch(fetchEmailConversationListFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

/*------------*/
export const FETCH_SMS_CONVERSATION_LIST_PROGRESS =
  "FETCH_SMS_CONVERSATION_LIST_PROGRESS";
export const FETCH_SMS_CONVERSATION_LIST_SUCCESS =
  "FETCH_SMS_CONVERSATION_LIST_SUCCESS";
export const FETCH_SMS_CONVERSATION_LIST_FAILED =
  "FETCH_SMS_CONVERSATION_LIST_FAILED";

export const fetchSMSConversationListProgress = () =>
  action(FETCH_SMS_CONVERSATION_LIST_PROGRESS);
export const fetchSMSConversationListSuccess = (data: ISMSActivity[]) =>
  action(FETCH_SMS_CONVERSATION_LIST_SUCCESS, { data });
export const fetchSMSConversationListFailed = (errorMesssage: string) =>
  action(FETCH_SMS_CONVERSATION_LIST_FAILED, { errorMesssage });

export const fetchSMSConversationListAsync =
  (code: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchSMSConversationListProgress());

      const res = await api.get(
        `/general/get-email-history?module_code=${code}`,
      );
      const data: ISMSActivity[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchSMSConversationListSuccess(data));
      } else {
        dispatch(
          fetchSMSConversationListFailed(ERROR_MESSAGES.NO_RECORD_FOUND),
        );
      }
    } catch (err: any) {
      dispatch(fetchSMSConversationListFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCG_CUSTOMER_INVOICE_LIST_PROGRESS =
  "FETCG_CUSTOMER_INVOICE_LIST_PROGRESS";
export const FETCG_CUSTOMER_INVOICE_LIST_SUCCESS =
  "FETCG_CUSTOMER_INVOICE_LIST_SUCCESS";
export const FETCG_CUSTOMER_INVOICE_LIST_FAILED =
  "FETCG_CUSTOMER_INVOICE_LIST_FAILED";

export const fetchCustomerInvoiceListProgress = () =>
  action(FETCG_CUSTOMER_INVOICE_LIST_PROGRESS);
export const fetchCustomerInvoiceListSuccess = (data: IInvoiceInformation[]) =>
  action(FETCG_CUSTOMER_INVOICE_LIST_SUCCESS, { data });
export const fetchCustomerInvoiceListFailed = (error: string) =>
  action(FETCG_CUSTOMER_INVOICE_LIST_FAILED, { error });

export const fetchCustomerInvoiceListAsync =
  (customerId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCustomerInvoiceListProgress());
      const finalUrl = `/accounting/get-account-invoice?customer_id=${customerId}`;

      const res = await api.get(finalUrl);
      const data: IInvoiceInformation[] = res.data.data;
      if (data.length === 0) {
        dispatch(
          fetchCustomerInvoiceListFailed(ERROR_MESSAGES.NO_RECORD_FOUND),
        );
      } else {
        dispatch(fetchCustomerInvoiceListSuccess(data));
      }
    } catch (err: any) {
      dispatch(fetchCustomerInvoiceListFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_ACTIVITY_COMMENTS_LIST_PROGRESS =
  "FETCH_ACTIVITY_COMMENTS_LIST_PROGRESS";
export const FETCH_ACTIVITY_COMMENTS_LIST_SUCCESS =
  "FETCH_ACTIVITY_COMMENTS_LIST_SUCCESS";
export const FETCH_ACTIVITY_COMMENTS_LIST_FAILED =
  "FETCH_ACTIVITY_COMMENTS_LIST_FAILED";

export const fetchActivityCommentsListProgress = () =>
  action(FETCH_ACTIVITY_COMMENTS_LIST_PROGRESS);
export const fetchActivityCommentsListSuccess = (data: IActivityComment[]) =>
  action(FETCH_ACTIVITY_COMMENTS_LIST_SUCCESS, { data });
export const fetchActivityCommentsListFailed = (error: string) =>
  action(FETCH_ACTIVITY_COMMENTS_LIST_FAILED, { error });

export const fetchActivityCommentsListAsync =
  (code: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchActivityCommentsListProgress());

      const res = await api.get(`/general/get-comments?type_id=${code}`);
      const data: IActivityComment[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchActivityCommentsListSuccess(data));
      } else {
        dispatch(
          fetchActivityCommentsListFailed(ERROR_MESSAGES.NO_RECORD_FOUND),
        );
      }
    } catch (err: any) {
      dispatch(fetchActivityCommentsListFailed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const ADD_ACTIVITY_COMMENT = "ADD_ACTIVITY_COMMENT";
export const addActivityComment = (data: IActivityComment) =>
  action(ADD_ACTIVITY_COMMENT, { data });

export const upsertActivityCommentAysnc =
  (
    comment: IActivityComment,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.post("/general/upsert-comments", comment);
      if (res.data.data) {
        dispatch(addActivityComment({ ...res.data.data, insert_ts: moment() }));
        dispatch(
          showMessage({
            type: "success",
            message: "Comment added successfully",
            displayAs: "snackbar",
          }),
        );
      }
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/*-----------*/

export const FETCH_WHATSAPP_CONVERSATION_LIST_PROGRESS =
  "FETCH_WHATSAPP_CONVERSATION_LIST_PROGRESS";
export const FETCH_WHATSAPP_CONVERSATION_LIST_SUCCESS =
  "FETCH_WHATSAPP_CONVERSATION_LIST_SUCCESS";
export const FETCH_WHATSAPP_CONVERSATION_LIST_FAILED =
  "FETCH_WHATSAPP_CONVERSATION_LIST_FAILED";

export const fetchWhatsAppConversationListProgress = (
  isRefresh: boolean,
  disableLoader?: boolean,
) =>
  action(FETCH_WHATSAPP_CONVERSATION_LIST_PROGRESS, {
    isRefresh,
    disableLoader,
  });
export const fetchWhatsAppConversationListSuccess = (
  data: IWhatsAppActivity[],
  isRefresh: boolean,
) => action(FETCH_WHATSAPP_CONVERSATION_LIST_SUCCESS, { data, isRefresh });
export const fetchWhatsAppConversationListFailed = (errorMesssage: string) =>
  action(FETCH_WHATSAPP_CONVERSATION_LIST_FAILED, { errorMesssage });

export const fetchWhatsAppConversationListAsync =
  (
    code: string,
    pageNo: number,
    rowsInPerPage: number,
    isRefresh: boolean,
    companyOutletUuid?: string,
    whatsapp_web_service: boolean = true, // Default to true (QR), now mandatory
    onCallback?: () => void,
    disableLoader?: boolean,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const phone = code; //code.replace(/^\+91\s?/, "");
      if (!disableLoader) {
        dispatch(
          fetchWhatsAppConversationListProgress(isRefresh, disableLoader),
        );
      }

      const url = `conversation/get-whatsapp-messages-history?phone_number=${phone}&pageNo=${pageNo}&itemPerPage=${rowsInPerPage}&company_outlet_uuid=${companyOutletUuid}&whatsapp_web_service=${whatsapp_web_service}`;

      const res = await api.get(url);
      const data: IWhatsAppActivity[] = res.data.data;

      dispatch(fetchWhatsAppConversationListSuccess(data, isRefresh));

      if (onCallback) {
        onCallback();
      }
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message;

      // Check if the error is specifically about WhatsApp not being scanned
      if (errorMessage === "Whatsapp is not scanned") {
        dispatch(fetchWhatsAppConversationListFailed("WHATSAPP_NOT_SCANNED"));
      } else if (errorMessage === "Whatsapp Service OFF") {
        dispatch(fetchWhatsAppConversationListFailed("WHATSAPP_SERVICE_OFF"));
      } else {
        dispatch(
          fetchWhatsAppConversationListFailed(ERROR_MESSAGES.SERVER_ERROR),
        );
        dispatch(
          showMessage({
            type: "error",
            message: errorMessage,
            displayAs: "snackbar",
          }),
        );
      }
    }
  };

export const fetchIsWhatsAppConversationStartedAsync =
  (
    code: string,

    onCallback: (value: number) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const phone = code.replace(/^\+91\s?/, "");
      const res = await api.get(
        `/conversation/is-whatsapp-conversation-started?from_number=${phone}`,
      );
      const data: number = res.data.data.value;

      onCallback(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const fetchScannedPhoneNumberAsync =
  (
    reference_column_uuid: string,
    onCallback: (value: string) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const res = await api.get(
        `/conversation/get-scanned-phone-number?reference_column_uuid=${reference_column_uuid}`,
      );

      const data = res.data.formatted;

      onCallback(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const refreshServerQRCodeAsync =
  (
    onCallback?: (data: any) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const res = await api.get(`/conversation/refresh-server`);

      const data = res.data.data;

      onCallback?.(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const UPSERT_MESSAGE = "UPSER_MESSAGE";
export const upsertMessage = (data: IWhatsAppActivity) =>
  action(UPSERT_MESSAGE, { data });

export const upsertWhatsAppMessage =
  (
    data: IWhatsAppActivityPayload,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const res = await makeApiCall(
        {
          url: "/conversation/whatsapp-send-messages",
          method: "POST",
        },
        {},
        {
          ...data,
        },
      );
      // dispatch(upsertMessage(res.data.data));

      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const markAsReadAsync =
  (
    phone: string,
    onCallback?: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await api.post(
        `/conversation/mark-as-read?phone_number=${phone}`,
      );
      if (res.status === 200) {
        dispatch(
          showMessage({
            type: "success",
            message: "Message marked as read successfully",
            displayAs: "snackbar",
          }),
        );
        onCallback?.(true);
      }
    } catch (err: any) {
      onCallback?.(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const restrictWhatsAppMessageAsync =
  (
    data: IRestrictWhatsAppMessagePayload,
    onCallback?: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await api.post(`/general/upsert-restricted-word`, data);
      if (res.status === 200) {
        dispatch(
          showMessage({
            type: "success",
            message: "Message restricted successfully",
            displayAs: "snackbar",
          }),
        );
        onCallback?.(true);
      }
    } catch (err: any) {
      onCallback?.(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const roughEstimateSendWhatsAppMessage =
  (
    rough_estimate_uuid: string,
    onCallback: (isSuccess: boolean, data: any) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const res = await api.post(
        `/leads/rough-estimate/${rough_estimate_uuid}/send-whatsapp`,
      );

      onCallback(true, res.data.data);
    } catch (err: any) {
      onCallback(false, null);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_PROGRESS =
  "FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_PROGRESS";
export const FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_SUCCESS =
  "FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_SUCCESS";
export const FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_FAILED =
  "FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_FAILED";

export const fetchWhatsAppGroupConversationListProgress = (
  isRefresh: boolean,
) => action(FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_PROGRESS, { isRefresh });
export const fetchWhatsAppGroupConversationListSuccess = (
  data: IWhatsAppGroupActivity[],
  isRefresh: boolean,
  isGroupConnected: boolean,
  groups: IGroup[],
) =>
  action(FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_SUCCESS, {
    data,
    isRefresh,
    isGroupConnected,
    groups,
  });
export const fetchWhatsAppGroupConversationListFailed = (
  errorMesssage: string,
) => action(FETCH_WHATSAPP_GROUP_CONVERSATION_LIST_FAILED, { errorMesssage });

export const fetchWhatsAppGroupConversationListAsync =
  (
    moduleName: string,
    moduleId: string,
    pageNo: number,
    rowsInPerPage: number,
    isRefresh: boolean,
    onCallback?: () => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      //const phone = code.replace(/^\+91\s?/, "");
      dispatch(fetchWhatsAppGroupConversationListProgress(isRefresh));
      const res = await api.get(
        `/conversation/get-group-messages?module_name=${moduleName}&module_uuid=${moduleId}&pageNo=${pageNo}&itemPerPage=${rowsInPerPage}`,
      );
      const data: IWhatsAppGroupActivity[] = res.data.data.result;
      const isGroupConnected = res.data.data.isGroupConnected;
      let groups: IGroup[] = [];
      if (!isGroupConnected) {
        const res = await api.get(`/conversation/get-all-groups`);
        groups = res.data.data.groups;
      }

      dispatch(
        fetchWhatsAppGroupConversationListSuccess(
          data,
          isRefresh,
          isGroupConnected,
          groups,
        ),
      );

      if (onCallback) {
        onCallback();
      }
    } catch (err: any) {
      dispatch(
        fetchWhatsAppGroupConversationListFailed(ERROR_MESSAGES.SERVER_ERROR),
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

// export const UPSERT_GROUP_MESSAGE = "UPSERT_GROUP_MESSAGE";
// export const upsertGroupMessage = (data: IWhatsAppActivity) =>
//   action(UPSERT_GROUP_MESSAGE, { data });

export const createGroup =
  (
    data: ICreateGroupPayload,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      await api.post("/conversation/link-whatsapp-group-to-module", data);

      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
/*---- */

export const changeInternalStatusAsync =
  (conversationIds: string[]): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.put("/conversation/change-internal-status", {
        conversation_ids: conversationIds,
      });
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_WHATSAPP_STATUS_COUNT_PROGRESS =
  "FETCH_WHATSAPP_STATUS_COUNT_PROGRESS";
export const FETCH_WHATSAPP_STATUS_COUNT_SUCCESS =
  "FETCH_WHATSAPP_STATUS_COUNT_SUCCESS";
export const FETCH_WHATSAPP_STATUS_COUNT_FAILED =
  "FETCH_WHATSAPP_STATUS_COUNT_FAILED";

export const fetchWhatsappStatusCountProgress = () =>
  action(FETCH_WHATSAPP_STATUS_COUNT_PROGRESS);
export const fetchWhatsappStatusCountSuccess = (data: IWhatsAppStatusCount[]) =>
  action(FETCH_WHATSAPP_STATUS_COUNT_SUCCESS, { data });
export const fetchWhatsappStatusCountFailed = () =>
  action(FETCH_WHATSAPP_STATUS_COUNT_FAILED);

export const fetchWhatsappStatusCountAsync =
  (
    date: IDataTableV2DateState["dates"],
    companyOutlet?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchWhatsappStatusCountProgress());
      let url = "";
      if (companyOutlet) {
        url += `&company_outlet_uuid=${companyOutlet}`;
      }
      const finalUrl =
        `/dashboard/get-whatsapp-status-count?type=count&from_date=${date.fromDate}&to_date=${date.toDate}` +
        url;
      const res = await api.get(finalUrl);
      const data: IWhatsAppStatusCount[] = res.data.data.statusCounts;
      dispatch(fetchWhatsappStatusCountSuccess(data || []));
    } catch (err: any) {
      dispatch(fetchWhatsappStatusCountFailed());
      // dispatch(
      // 	showMessage({
      // 		type: "error",
      // 		message: err.response?.data?.message || "Whatsapp Number not found",
      // 		displayAs: "snackbar",
      // 	})
      // );
    }
  };

export const FETCH_WHATSAPP_LIST_STATUS_COUNT_PROGRESS =
  "FETCH_WHATSAPP_LIST_STATUS_COUNT_PROGRESS";
export const FETCH_WHATSAPP_LIST_STATUS_COUNT_SUCCESS =
  "FETCH_WHATSAPP_LIST_STATUS_COUNT_SUCCESS";
export const FETCH_WHATSAPP_LIST_STATUS_COUNT_FAILED =
  "FETCH_WHATSAPP_LIST_STATUS_COUNT_FAILED";

export const fetchWhatsappListStatusCountProgress = () =>
  action(FETCH_WHATSAPP_LIST_STATUS_COUNT_PROGRESS);
export const fetchWhatsappListStatusCountSuccess = (
  list: IWhatsAppActivity[],
  totalRecords: number,
) =>
  action(FETCH_WHATSAPP_LIST_STATUS_COUNT_SUCCESS, {
    list,
    totalRecords,
  });
export const fetchWhatsappListStatusCountFailed = () =>
  action(FETCH_WHATSAPP_LIST_STATUS_COUNT_FAILED);

export const fetchWhatsappLeadListStatusCountAsync =
  (
    type: string,
    status: string,
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    company_outlet_uuid?: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchWhatsappListStatusCountProgress());
      dispatch(saveLoaderProgress());

      let url = "";
      if (status !== "-1") {
        url += `&list_for=${status}`;
      }

      if (searchValue.length > 0) {
        url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (type) {
        url += `&type=${type}`;
      }
      if (company_outlet_uuid) {
        url += `&company_outlet_uuid=${company_outlet_uuid}`;
      }

      const finalUrl =
        `/dashboard/get-whatsapp-status-count?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}` +
        url;
      const res = await api.get(finalUrl);
      const data: IWhatsAppActivity[] = res.data.data;

      const totalRecords = res.data.totalRecords;

      dispatch(fetchWhatsappListStatusCountSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchWhatsappListStatusCountFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_WHATS_APP_CHAT = "CLEAR_WHATS_APP_CHAT";
export const clearWhatsAppChat = () => action(CLEAR_WHATS_APP_CHAT);

export const CLEAR_WHATS_APP_GROUP_CHAT = "CLEAR_WHATS_APP_GROUP_CHAT";
export const clearWhatsAppGroupChat = () => action(CLEAR_WHATS_APP_GROUP_CHAT);

export const CLEAR_ACTIVITY_STATE = "CLEAR_ACTIVITY_STATE";
export const clearActivityState = () => action(CLEAR_ACTIVITY_STATE);
